import React from 'react';
import { isEmpty, noop } from 'lodash';
import { object, string, bool, func } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import Header from '../Dropdown/Header';
import Entry from '../Dropdown/Entry';
import { compareIndustries } from './utils';

const Entries = ({
    industries = {},
    headerKey = '',
    selected = null,
    displayAllIndustries = false,
    onChange = noop,
}) => {
    if (isEmpty(industries)) {
        return null;
    }

    const entries = Object.entries(industries).sort(compareIndustries);

    return (
        <>
            <Header>
                <I18n k={headerKey} />
            </Header>
            {displayAllIndustries && (
                <Entry selected={!selected} onClick={onChange}>
                    <I18n k="reviews.filters.all_industry" />
                </Entry>
            )}
            {entries.map(([key, value]) => (
                <Entry key={key} industryKey={key} value={value} selected={selected === key} onClick={onChange} />
            ))}
        </>
    );
};

Entries.propTypes = {
    industries: object,
    headerKey: string,
    selected: string,
    displayAllIndustries: bool,
    onChange: func,
};

export default Entries;
